import { createAsyncThunk } from '@reduxjs/toolkit';

import { authSet } from '../../../utils/request';
import { METHOD_POST } from '../../../constants/api';

const postCoMissingParts = createAsyncThunk('coOrders/postCoMissingParts',
  async (form, { rejectWithValue }) => {
    try {
      return await authSet(METHOD_POST, '/co/orders/missing_parts', form);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  });

export default postCoMissingParts;
